import { Skeleton, Stack } from "@mui/material"
import { noop } from "lodash"
import { FC, useEffect } from "react"
import { FeatureEnum } from "shared/featureData"
import useFeatures from "src/features/things/useFeatures"
import { useAppSelector } from "../app/hooks"
import { selectMeIsReady, selectTenantId } from "../features/me/meSlice"
import OsReportReservationLockerOccupancy from "./OsReportReservationLockerOccupancy"
import OsReportReservationLockerOccupancyDow from "./OsReportReservationLockerOccupancyDow"
import OsReportReservationLockerOccupancyHod from "./OsReportReservationLockerOccupancyHod"
import OsReportReservationNewClients from "./OsReportReservationNewClients"
import OsReportReservationSummary from "./OsReportReservationSummary"
import OsReportReservationSummaryPickupDelay from "./OsReportReservationSummaryPickupDelay"
import OsReportReservationSummaryPickupHod from "./OsReportReservationSummaryPickupHod"

type OsReportingKPIsProps = {
  onRefresh?: () => void
  isLoading?: boolean
}
export const OsReportingKPIs: FC<OsReportingKPIsProps> = ({
  onRefresh = noop,
  isLoading = false,
}) => {
  const isReady = useAppSelector(selectMeIsReady)
  const tenantId = useAppSelector(selectTenantId)
  // LOCKER-454 — per-tenant feature, enforced server-side too (the report
  // 403s when off); this only keeps the charts from rendering a refusal.
  const { canUseFeature } = useFeatures(tenantId)
  const showOccupancy = canUseFeature(FeatureEnum.LockerOccupancyReport)

  useEffect(() => {
    onRefresh()
  }, [onRefresh])

  return (
    <div data-ui="UI-SL2W-091" style={{ display: "contents" }}>
      {!isReady && (
        <>
          <Stack direction="column" spacing={2}>
            <Skeleton variant="rectangular" width="100%" height={118} />
            <Skeleton variant="rectangular" width="100%" height={118 / 2} />
            <Skeleton variant="rectangular" width="100%" height={118} />
            <Skeleton variant="rectangular" width="100%" height={118 / 2} />
          </Stack>
        </>
      )}
      {isReady && (
        <Stack
          direction={"column"}
          spacing={4}
          maxWidth="1000px"
          width="1000px"
        >
          <OsReportReservationSummary />
          <OsReportReservationSummaryPickupHod />
          <OsReportReservationSummaryPickupDelay />
          <OsReportReservationNewClients />
          {showOccupancy && (
            <>
              <OsReportReservationLockerOccupancy />
              <OsReportReservationLockerOccupancyDow />
              <OsReportReservationLockerOccupancyHod />
            </>
          )}
        </Stack>
      )}
    </div>
  )
}

export default OsReportingKPIs
